export const componentConversationStyles = {
    headingStyle: {
        color: "#476788", fontSize: "42px", marginBottom: "43px", marginRight: "82px", fontWeight: "700", 
    }
  };